import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=1778c41c&scoped=true"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"
import style0 from "./wait.vue?vue&type=style&index=0&id=1778c41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778c41c",
  null
  
)

export default component.exports